<template>
  <Catalog
    title="Нарекания исполнителя"
    name-label="Название"
    submit-error="Укажите название."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import Catalog from "../Catalog.vue";

export default {
  name: "WorkerComplaint",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getWorkerComplaintById(id);
    },
    async putData(data) {
      return await this.putWorkerComplaint(data);
    },
    async postData(data) {
      return await this.postWorkerComplaint(data);
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerComplaints/WorkerComplaint.vue